import { render, staticRenderFns } from "./AccountTransactionList.vue?vue&type=template&id=06f79b48&"
import script from "./AccountTransactionList.vue?vue&type=script&lang=js&"
export * from "./AccountTransactionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports